module.exports = __webpack_public_path__ + "assets/img/ju1.a1e964f5.png";